const validateAnswer = function (errors, vm, showTip, valIndex) {
  const { answerConfig: { requireInd, scoreVerification, scoreRepeatNum, scoreRepeatTips }, descList } = this
  let descListFilter = descList.filter(item => item.visibility)

  if (requireInd === '1') {
    if (valIndex !== undefined && !descListFilter[valIndex].value && sessionStorage.getItem('descChangeStatus') === '1') {
      errors.push(vm.cvtLang('tipScoreNull', vm.surveyInfoLang.tipScoreNull))
      return !errors.length
    }

    if (valIndex === undefined && sessionStorage.getItem('descChangeStatus') === '1' && descListFilter.some((item, index) => {
      return !item.value
    })) {
      errors.push(vm.cvtLang('tipScoreNull', vm.surveyInfoLang.tipScoreNull))
      return !errors.length
    }
  }

  // if (valIndex === undefined) {
  //   // TODO: 兼容点击提交按钮时全局校验undfined问题
  //   valIndex = 0
  // }
  // if (scoreVerification === '1' && valIndex !== undefined) {
  //   const currVal = descListFilter[valIndex].value
  //   const valArr = descListFilter.filter(item => item.value).map(item => (item.value))
  //   const someVal = valArr.filter(item => item === currVal)
  //   if (someVal.length > scoreRepeatNum) {
  //     errors.push(vm.cvtLang(this.id + 'scoreRepeatTips', scoreRepeatTips))
  //     return !errors.length
  //   }
  // }

  return !errors.length
}

const validate = function (vm, showTip, valIndex) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip, valIndex),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/RateGroupBox/answerValidate.js